<script setup>
import {
  Dialog,
  DialogDescription,
  DialogHeader,
  DialogScrollContent,
  DialogTitle,
  DialogTrigger,
} from '@codinglabsau/gooey'
import { InfoIcon } from 'lucide-vue-next'
import Reputation from './Reputation.vue'

defineProps({
  triggerClass: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <Dialog>
    <DialogTrigger as-child :class="triggerClass">
      <slot name="trigger">
        <InfoIcon class="size-4 cursor-pointer" />
      </slot>
    </DialogTrigger>

    <DialogScrollContent class="max-w-4xl">
      <DialogHeader class="text-left">
        <DialogTitle>Reputation</DialogTitle>
        <DialogDescription>
          You can gain reputation through various contributions to this site. If a task requires
          moderation then you will not gain reputation until the contribution has been approved.
        </DialogDescription>
      </DialogHeader>
      <Reputation />
    </DialogScrollContent>
  </Dialog>
</template>
